module.exports = __webpack_public_path__ + "img/www.insiderpages.com.50a899c2.png";